import axiosInstance from '@/utils/api.js'

var state = {
  tv24Users: {
    items: [],
    total: 0
  },
  tv24UserSubscriptions: [],
  tv24AvailableTariffs: [],
  tv24SyncSubscriptions: []
}

var getters = {
  TV_24_USERS: (state) => {
    return state.tv24Users
  },
  TV_24_AVAILABLE_TARIFFS: (state) => {
    return state.tv24AvailableTariffs
  },
  TV_24_USER_SUBSCRIPTIONS: (state) => {
    return state.tv24UserSubscriptions
  },
  TV_24_SYNC_SUBSCRIPTIONS: (state) => {
    return state.tv24SyncSubscriptions
  }
}

var mutations = {
  SET_TV_24_USERS: (state, payload) => {
    state.tv24Users = payload
  },
  SET_TV_24_AVAILABLE_TARIFFS: (state, payload) => {
    state.tv24AvailableTariffs = payload
  },
  SET_TV_24_USER_SUBSCRIPTIONS: (state, payload) => {
    state.tv24UserSubscriptions = payload
  },
  SET_TV_24_SYNC_SUBSCRIPTIONS: (state, payload) => {
    state.tv24SyncSubscriptions = payload
  }
}

var actions = {
  GET_TV_24_USERS: async (context, payload) => {
    context.commit('SET_TV_24_USERS', {
      items: [],
      total: 0
    })
    let result = await axiosInstance.get('/integrations/24tv/users?limit=' + payload.limit + '&offset=' + payload.offset +
    '&username=' + payload.username + '&phone=' + payload.phone + '&email=' + payload.email)
    if (result.status === 200) {
      context.commit('SET_TV_24_USERS', result.data)
    }
  },
  GET_TV_24_AVAILABLE_TARIFFS: async (context, payload) => {
    let result = await axiosInstance.get('/integrations/24tv/available_tariffs')
    if (result.status === 200) {
      context.commit('SET_TV_24_AVAILABLE_TARIFFS', result.data)
    }
  },
  GET_TV_24_USER_SUBSCRIPTIONS: async (context, payload) => {
    let result = await axiosInstance.get('/integrations/24tv/user_subscriptions?24tv_user_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_TV_24_USER_SUBSCRIPTIONS', result.data)
    }
  },
  GET_TV_24_SYNC_SUBSCRIPTIONS: async (context, payload) => {
    context.commit('SET_TV_24_SYNC_SUBSCRIPTIONS', [])
    let result = await axiosInstance.get('/integrations/24tv/sync/all_users_w_subscriptions?limit=' + payload.limit + '&offset=' + payload.offset)
    if (result.status === 200) {
      context.commit('SET_TV_24_SYNC_SUBSCRIPTIONS', result.data)
    }
  },
  PAUSE_TV_24_USER_SUBSCRIPTION: (context, payload) => {
    return axiosInstance.post('/integrations/24tv/pause_user_subscription?24tv_user_id=' + payload.user_id + '&subscription_id=' + payload.subscription_id, '')
  },
  POST_TV_24_SYNC_ALL_SUBSCRIPTIONS: (context, payload) => {
    return axiosInstance.post('/integrations/24tv/sync/synchronize_all', '')
  },
  POST_TV_24_SYNC_SUBSCRIPTIONS: (context, payload) => {
    return axiosInstance.post('/integrations/24tv/sync/synchronize?user_id=' + payload, '')
  },
  PAUSE_ALL_TV_24_USER_SUBSCRIPTION: (context, payload) => {
    return axiosInstance.post('/integrations/24tv/pause_all_user_subscriptions?24tv_user_id=' + payload.user_id, '')
  },
  RESUME_TV_24_USER_SUBSCRIPTION: (context, payload) => {
    return axiosInstance.post('/integrations/24tv/resume_user_subscription?24tv_user_id=' + payload.user_id + '&subscription_id=' + payload.subscription_id + '&pause_id=' + payload.pause_id, '')
  },
  RESUME_ALL_TV_24_USER_SUBSCRIPTION: (context, payload) => {
    return axiosInstance.post('/integrations/24tv/resume_all_user_subscription?24tv_user_id=' + payload.user_id, '')
  },
  ADD_TV_24_USER: (context, payload) => {
    return axiosInstance.post('/integrations/24tv/add_user', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/24tv.js